<script>
import Layout from "../../layouts/main";
import {
  FETCH_RECON_REPORTS,
  FETCH_RECON_REPORT_FILTERS,
  CREATE_RECON_REPORT,
  FETCH_UNRESOLVED_QA_LOGS,
} from "@/state/actions.type";
import PerPage from "../../../components/per-page.vue";
import CloseModalBtn from "../../../components/close-modal-btn.vue";
import Multiselect from "vue-multiselect";
import Country from "../../../components/country.vue";
import DaySelection from "../../../components/day-selection.vue";
import DatePicker from "vue2-datepicker";
// import DownloadBtn from "../../../components/download-btn.vue";
import moment from "moment";
import { required } from "vuelidate/lib/validators";
import Common from "../../../helpers/Common";
import { requiredIf } from "vuelidate/lib/validators";
export default {
  components: {
    Layout,
    PerPage,
    CloseModalBtn,
    Multiselect,
    Country,
    DaySelection,
    DatePicker,
    // DownloadBtn,
  },
  validations: {
    form: {
      marketplace: { required: requiredIf(function () {
        return !this.isBrandReport
      }) },
      account_id: { required: requiredIf(function () {
        return !this.isBrandReport
      }) },
      country: { required },
      order_type: { required: requiredIf(function () {
        return !this.isBrandReport && (!this.form.date_type || (this.isAmazon && this.form.date_type && this.form.date_type.order_types))
      }) },
      date_type: { required: requiredIf(function () {
        return !this.isBrandReport && !this.form.order_type
      }) },
      from_date: { required: requiredIf(function () {
        return !this.isBrandReport && !this.isSettlementMonthMode
      }) },
      to_date: { required: requiredIf(function () {
        return !this.isBrandReport && !this.isSettlementMonthMode
      }) },
      brand: { required: requiredIf(function () {
        return this.isBrandReport
      }) },
      report_month: { required: requiredIf(function () {
        return this.isBrandReport
      }) },
    },
    day: { required: requiredIf(function () {
      return !this.isBrandReport
    }) },
  },
  data() {
    return {
      fields: [
        {
          key: "file_name",
          sortable: false,
          label: "views.reconciliation.table.fields.file_name",
        },
        { key: "marketplace", sortable: false, label: "Marketplace" },
        { key: "brand", sortable: false, label: "Brand" },
        { key: "order_type", sortable: false, label: "Order Type" },
        { key: "date_type", sortable: false, label: "Date Type" },
        { key: "country", sortable: false, label: "Country" },
        { key: "from_date", sortable: false, label: "Date Range Start" },
        { key: "to_date", sortable: false, label: "Date Range End" },
        { key: "generated_at", sortable: false, label: "Created at" },
        // { key: "report_type", sortable: false, label: "Report Type" },
        { key: "status", sortable: false, stickyColumn: true, label: "Status" },
      ],
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      currentPage: 1,
      isFetching: false,
      filters: {
        brand: [],
        country: [],
        marketplace: [],
        report_type: [],
        status: [],
      },
      form: {
        marketplace: null,
        account_id: null,
        country: null,
        from_date: null,
        to_date: null,
        order_type: null,
        date_type: null,
        brand: null,
        report_month: null,
        settlement_month: null,
      },
      generate_generic_report: false,
      day: "Custom",
      openDatePickerFrom: false,
      openDatePickerTo: false,
      loading: true,
      processing: false,
      flags: Common.flagByCountry(),
      marketplaceIcons: {
        'QOO10': require('@/assets/images/Qoo10.svg'),
        'SHOPEE': require('@/assets/images/shopee.png'),
        'AMAZON': require('@/assets/images/Amazon.svg'),
        'SHOPIFY': require('@/assets/images/Shopify.svg'),
        'RAKUTEN': require('@/assets/images/rakuten.svg'),
        'TIKTOK': require('@/assets/images/tiktok.png'),
      },
      downloadingRowKeys: {},
      isFetchingUnresolvedQaLogs: false,
    };
  },
  filters: {
    date(value) {
      if(value.startsWith('0001')) return 'NA';
      return moment.utc(value).format("DD/MM/YYYY");
    },
    time(value) {
      return moment.utc(value).format("h:mm A");
    },
    localDate(value) {
      return moment(value).format("DD/MM/YYYY");
    },
    localTime(value) {
      return moment(value).format("h:mm A");
    },
    // getRegionName(countryCode) {
    //   if (countryCode.length > 2) {
    //     return countryCode;
    //   }
    //   return new Intl.DisplayNames("en", {
    //     type: "region",
    //     fallback: "code",
    //   }).of(countryCode);
    // },
  },
  computed: {
    isAmazon() {
      return this.form.marketplace && this.form.marketplace.name === 'AMAZON';
    },
    // ENG-1175: Shopify Settlement Basis can be requested by Settlement Month instead of From/To. Shown
    // only when the backend advertises it on the selected date type (supports_settlement_month), so every
    // other marketplace and date type is untouched.
    isSettlementMonthAvailable() {
      return !!(
        this.form.marketplace &&
        this.form.marketplace.name === 'SHOPIFY' &&
        this.form.date_type &&
        this.form.date_type.supports_settlement_month
      );
    },
    isSettlementMonthMode() {
      return this.isSettlementMonthAvailable && !!this.form.settlement_month;
    },
    tableData() {
      return this.$store.state.reconReports.content;
    },
    marketplaces() {
      return this.$store.state.reconReports.selection.marketplaces || [];
    },
    availableFilters() {
      return this.$store.state.reconReports.filters;
    },
    rows() {
      return this.$store.state.reconReports.total_elements;
    },
    unresolvedQaLogs() {
      return this.$store.state.reconReports.unresolved_qa_logs || {
        groups: [],
        total: 0,
      };
    },
    qaMarketplaces() {
      const marketplacesSet = new Set();
      const groups = this.unresolvedQaLogs.groups || [];

      groups.forEach((group) => {
        (group.marketplaces || []).forEach((mp) => {
          if (mp && mp.marketplace) {
            marketplacesSet.add(mp.marketplace);
          }
        });
      });

      return Array.from(marketplacesSet).sort();
    },
    isBrandReport() {
      return this.$store.state.reconConfig.is_brand_report_enabled;
    },
    brandReportFilters() {
      return this.$store.state.reconReports.filters;
    },
    dayOptions() {
      let options = [];
      if (this.form.order_type && this.form.order_type.settlements) {
        options = this.form.order_type.settlements.map((settlement) => {
          settlement.label = `${settlement.date_range}`;
          if (settlement.settlement_id) {
            if(settlement.date_range) {
              settlement.label += ` [${settlement.settlement_id}]`;
            } else {
              settlement.label = `${settlement.settlement_id}`;
            }
          }
          return settlement;
        });
      } else if(this.form.date_type && this.form.date_type.settlements) {
        options = this.form.date_type.settlements.map((settlement) => {
          settlement.label = `${settlement.date_range}`;
          if (settlement.settlement_id) {
            if(settlement.date_range) {
              settlement.label += ` [${settlement.settlement_id}]`;
            } else {
              settlement.label = `${settlement.settlement_id}`;
            }
          }
          return settlement;
        });
      }
      options.push("Custom");
      return options;
    },
  },
  watch: {
    'form.marketplace'() {
      this.form.account_id = null;
    },
    'form.account_id'() {
      this.form.country = null;
    },
    'form.country'() {
      this.form.order_type = null;
      this.form.date_type = null;
    },
    // Choosing a Settlement Month replaces From/To: clear them (the pickers are disabled while a month is set).
    'form.settlement_month'(value) {
      if (value) {
        this.dayChanged({
          day: "Custom",
          openDatePicker: false,
          startDate: null,
          endDate: null,
        });
        this.openDatePickerTo = false;
      }
    },
    'form.order_type'() {
      this.dayChanged({
        day: "Custom",
        openDatePicker: false,
        startDate: null,
        endDate: null,
      });
    },
    'form.date_type'() {
      if (this.isAmazon) {
        this.form.order_type = null;
      }
      this.form.settlement_month = null;
      this.dayChanged({
        day: "Custom",
        openDatePicker: false,
        startDate: null,
        endDate: null,
      });
    },
  },
  created() {
    // Fetch reports data when the component is created
    console.log("Fetching reconciliation reports...");
    this.$store
      .dispatch(`reconReports/${FETCH_RECON_REPORT_FILTERS}`)
      .finally(() => {
        this.loading = false;
      });
    this.fetchReconReports();
    this.fetchUnresolvedQaLogs();
  },
  methods: {
    fetchReconReports() {
      this.isFetching = true;
      this.$store
        .dispatch(`reconReports/${FETCH_RECON_REPORTS}`, {
          request_source: "portone-dev",
          page: this.currentPage,
          pagesize: this.perPage,
          filters: this.filters,
        })
        .then(() => {
          this.isFetching = false;
        })
        .catch((error) => {
          console.error("Error fetching reports:", error);
          this.isFetching = false;
        });
    },
    fetchUnresolvedQaLogs() {
      this.isFetchingUnresolvedQaLogs = true;
      this.$store
        .dispatch(`reconReports/${FETCH_UNRESOLVED_QA_LOGS}`)
        .catch((error) => {
          console.error("Error fetching unresolved QA logs:", error);
        })
        .finally(() => {
          this.isFetchingUnresolvedQaLogs = false;
        });
    },
    toggleFilter() {
      this.$root.$emit("bv::toggle::collapse", "recon-records-filter-collapse");
    },
    resetFilter() {
      this.filters = {
        marketplace: [],
        account_id: [],
        country: [],
        report_type: [],
        status: [],
      };
      this.fetchReconReports();
    },
    dayChanged(value) {
      this.day = value.day;
      this.openDatePickerFrom = value.openDatePicker;

      this.form.from_date = value.startDate;
      this.form.to_date = value.endDate;
    },
    resetForm() {
      this.form = {
        marketplace: null,
        account_id: null,
        country: null,
        from_date: null,
        order_type: null,
        date_type: null,
        to_date: null,
        settlement_month: null,
      };
      this.generate_generic_report = false;
      this.day = "Custom";
      this.openDatePickerFrom = false;
      this.openDatePickerTo = false;
      this.$v.$reset();
      this.$v.form.$reset();
    },
    getRowKey(item) {
      return item.id != null ? String(item.id) : `${item.file_name || ""}-${item.generated_at || ""}`;
    },
    isRowDownloading(rowKey) {
      return Boolean(this.downloadingRowKeys[rowKey]);
    },
    async downloadReport(file_link, file_links, rowKey) {
      if (!rowKey) {
        this.$bvToast.toast("Unable to identify row for download.", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
        return;
      }
      if (file_links && file_links.length > 0) {
        this.$set(this.downloadingRowKeys, rowKey, true);
        try {
          await this.downloadReports(file_links);
          this.$bvToast.toast("All files downloaded successfully.", {
            title: "Success",
            variant: "success",
            solid: true,
            timeout: 2000,
          });
        } catch (err) {
          console.error("Download error:", err);
          this.$bvToast.toast("Some files could not be downloaded.", {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        } finally {
          this.$delete(this.downloadingRowKeys, rowKey);
        }
        return;
      }
      if (!file_link) {
        this.$bvToast.toast("No file link provided for download.", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
        return;
      }
      this.$set(this.downloadingRowKeys, rowKey, true);
      try {
        const link = document.createElement("a");
        link.href = file_link;
        link.setAttribute("download", "");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.$bvToast.toast("Download started successfully.", {
          title: "Success",
          variant: "success",
          solid: true,
          timeout: 2000,
        });
      } catch (err) {
        console.error("Download error:", err);
        this.$bvToast.toast("File could not be downloaded.", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      } finally {
        this.$delete(this.downloadingRowKeys, rowKey);
      }
    },
    async downloadReports(urls) {
      for (let i = 0; i < urls.length; i++) {
        const url = urls[i];
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute("download", "");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        await new Promise(resolve => setTimeout(resolve, 1000));
      }
      this.$bvToast.toast("Download started successfully.", {
        title: "Success",
        variant: "success",
        solid: true,
        timeout: 2000,
      });
    },
    createReport() {
      if (this.processing) return;
      this.$v.$touch();
      this.$v.form.$touch();
      if (this.$v.$invalid || this.$v.form.$invalid) {
        this.$bvToast.toast("Please fill in all required fields.", {
          title: "Validation Error",
          variant: "danger",
          solid: true,
          timeout: 2000,
        });
        return;
      }

      let payload = {};
      // const isShopify = this.form.marketplace && this.form.marketplace.name === "SHOPIFY";

      if(this.isBrandReport) {
        payload = {
          request_source: "portone-dev",
          report_type: "brand_report",
          brand: this.form.brand,
          country: this.form.country,
          from_date: moment(this.form.report_month)
            .startOf('month')
            .format("YYYY-MM-DD HH:mm:ss"),
          to_date: moment(this.form.report_month)
            .endOf('month')
            .format("YYYY-MM-DD HH:mm:ss"),
          date_range_type: "custom",
          is_brand_report: true
        }
      } else {
        payload = {
          request_source: "portone-dev",
          report_type: "consolidated_report",
          brand: this.form.account_id.name,
          account_id: this.form.account_id.id,
          marketplace: this.form.marketplace.name,
          country: this.form.country.name,
          order_type: this.form.order_type ? this.form.order_type.name : null,
          date_type: this.form.date_type ? this.form.date_type.name : null,
          from_date: moment(this.form.from_date)
            .set({ hour: 0, minute: 0, second: 0 })
            .format("YYYY-MM-DD HH:mm:ss"),
          to_date: moment(this.form.to_date)
            .set({ hour: 23, minute: 59, second: 59 })
            .format("YYYY-MM-DD HH:mm:ss"),
          settlement_id: this.day === "Custom" ? null : this.day.settlement_id,
          date_range_type: this.day === "Custom" ? "custom" : "settlement",
        }

        if(this.form.marketplace.name === 'TIKTOK') {
          payload["generate_generic_report"] = this.generate_generic_report;
        }

        // ENG-1175: month mode sends only the month; the backend derives the window and rejects from/to.
        if (this.isSettlementMonthMode) {
          payload.month = moment(this.form.settlement_month).format("YYYY-MM");
          payload.from_date = null;
          payload.to_date = null;
          payload.settlement_id = null;
          payload.date_range_type = "custom";
        }
      }



      this.processing = true;
      this.$store
        .dispatch(`reconReports/${CREATE_RECON_REPORT}`, payload)
        .then(() => {
          this.$bvToast.toast("Report created successfully.", {
            title: "Success",
            variant: "success",
            solid: true,
            timeout: 2000,
          });
          this.resetForm();
          this.$bvModal.hide("reports-modal");
          this.fetchReconReports();
        })
        .catch((error) => {
          const err = JSON.parse(error.message);
          console.error("Error creating report:", error);
          this.$bvToast.toast(err.message || "Failed to create report.", {
            title: "Error",
            variant: "danger",
            solid: true,
            timeout: 2000,
          });
        })
        .finally(() => {
          this.processing = false;
        });
    },
    disabledToDate(date) {
      // Disable dates before the selected from_date
      if (!this.form.from_date) return false;
      const oneMonthFromFromDate = new Date(this.form.from_date);
      const mp = this.form.marketplace && this.form.marketplace.name;
      if (mp === 'QOO10') {
        oneMonthFromFromDate.setMonth(oneMonthFromFromDate.getMonth() + 6);
      } else if (mp === 'RAKUTEN') {
        oneMonthFromFromDate.setMonth(oneMonthFromFromDate.getMonth() + 6);
      } else {
        oneMonthFromFromDate.setMonth(oneMonthFromFromDate.getMonth() + 6);
      }
      // deduct one day from max range end from fromdate
      // oneMonthFromFromDate.setDate(oneMonthFromFromDate.getDate() - 1);
      if (date > oneMonthFromFromDate) return true;
      // disable dates after the selected to_date
      return date < new Date(this.form.from_date);
    },
    disabledFromDate(date) {
      // Disable dates after the selected to_date
      if (!this.form.to_date) return false;
      const oneMonthAgo = new Date(this.form.to_date);
      const mp = this.form.marketplace && this.form.marketplace.name;
      if (mp === 'QOO10') {
        oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 6);
      } else if (mp === 'RAKUTEN') {
        oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 6);
      } else {
        oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 6);
      }
      // add one day to min range start from todate
      // oneMonthAgo.setDate(oneMonthAgo.getDate() + 1);
      if (date < oneMonthAgo) return true;
      // disable dates before the selected from_date
      return date > new Date(this.form.to_date);
    },
    getDateRangesForMarketplace(group, marketplaceName) {
      if (!group || !group.marketplaces) return [];
      const marketplace = group.marketplaces.find(
        (mp) => mp.marketplace === marketplaceName
      );
      return marketplace && marketplace.date_ranges
        ? marketplace.date_ranges
        : [];
    },
    formatQaDateRange(from, to) {
      if (!from || !to) {
        return "";
      }
      const fromMoment = moment(from, "DD MMM,YYYY");
      const toMoment = moment(to, "DD MMM,YYYY");

      if (!fromMoment.isValid() || !toMoment.isValid()) {
        return `${from} - ${to}`;
      }

      return `${fromMoment.format("DD MMM")} – ${toMoment.format("DD MMM")}`;
    },
    disabledReportMonth(date) {
      return date > new Date();
    },
    clearSettlementMonth() {
      this.form.settlement_month = null;
    },
    // Current month (partial) back 24 months.
    disabledSettlementMonth(date) {
      const earliest = moment().subtract(24, "months").startOf("month").toDate();
      return date > new Date() || date < earliest;
    },
  },
};
</script>

<template>
  <Layout>
    <div
      v-if="loading"
      class="d-flex justify-content-center"
      style="height: 90vh;"
    >
      <b-spinner small type="grow" class="my-auto"></b-spinner>
      <strong class="ml-2 my-auto">Loading...</strong>
    </div>
    <div v-else>
      <div class="d-flex justify-content-end mb-3">
        <b-btn
          variant="white"
          type="button"
          class="border border-dark mr-3"
          size="sm"
          @click="fetchReconReports"
        >
          <img
            src="@/assets/images/refresh.svg"
            alt="Reload"
          /> Reload
        </b-btn>

        <b-btn
          variant="white"
          type="button"
          class="border border-dark mr-3"
          size="sm"
          @click="toggleFilter"
        >
          <img
            style="padding-right: 10px;"
            src="@/assets/images/filter.svg"
            alt="Filter"
          />{{ $t("common.filters") }}
        </b-btn>

        <button
          @click="$bvModal.show('reports-modal')"
          type="button"
          class="btn btn-primary btn-sm"
          style="padding: 12px 16px;font-weight: 700;font-size: 14px;line-height: 20px;"
        >
          <span style="padding-right: 10px;">+</span>Create New Report
        </button>
      </div>
      <b-collapse
        id="recon-records-filter-collapse"
        @hidden="resetFilter"
        @show="resetFilter"
        style="padding: 25px;"
        class="common-border bg-white mb-1"
      >
        <div class="row">
          <div class="col-md-4" v-if="!isBrandReport">
            <label class="">{{ $t("Marketplace") }}</label>
            <Multiselect
              v-model="filters.marketplace"
              :options="availableFilters.marketplaces"
              :placeholder="$t('Marketplace')"
              :searchable="true"
              :multiple="true"
            ></Multiselect>
          </div>

          <div class="col-md-4" v-if="!isBrandReport">
            <label class="">{{ $t("Account ID") }}</label>
            <Multiselect
              v-model="filters.account_id"
              :options="availableFilters.account_ids"
              :placeholder="$t('Account ID')"
              :searchable="true"
              :multiple="true"
            ></Multiselect>
          </div>
          <div class="col-md-4">
            <label class="">{{ $t("country") }}</label>
            <Multiselect
              v-model="filters.country"
              :options="availableFilters.countries"
              :placeholder="$t('country')"
              :searchable="true"
              :multiple="true"
            ></Multiselect>
          </div>

          <div class="col-md-4">
            <label class="">{{ $t("Brand") }}</label>
            <Multiselect
              v-model="filters.brand"
              :options="availableFilters.brands"
              :placeholder="$t('Brand')"
              :searchable="true"
              :multiple="true"
            ></Multiselect>
          </div>
          <!-- <div class="col-md-4">
            <label class="">{{ $t("Report Type") }}</label>
            <Multiselect
              v-model="filters.report_type"
              :options="['consolidated_report', 'brand_report']"
              :placeholder="$t('Report Type')"
              :searchable="true"
              :multiple="true"
            ></Multiselect>
          </div> -->
          <div class="col-md-4" :class="{ 'mt-4': !isBrandReport }">
            <label class="">{{ $t("Status") }}</label>
            <Multiselect
              v-model="filters.status"
              :options="['Initiated', 'Successful']"
              :placeholder="$t('Status')"
              :searchable="true"
              :multiple="true"
            ></Multiselect>
          </div>
          <div class="col-md-4 mt-4 ml-auto d-flex justify-content-end">
            <b-button
              variant="white"
              class="mr-2 bg-white text-dark border-dark cancel"
              @click="toggleFilter"
              >{{ $t("button.cancel") }}</b-button
            >
            <b-button
              variant="primary"
              class="btn-padding"
              @click="fetchReconReports"
              >{{ $t("button.apply") }}</b-button
            >
          </div>
        </div>
      </b-collapse>
      <b-table
        class="table-custom"
        :items="tableData"
        :fields="fields"
        responsive="sm"
        sticky-header="80dvh"
        show-empty
        :empty-text="$t('common.no-records')"
        :busy="isFetching"
        hover
      >
        <template v-slot:head()="data">
          {{ $t(data.label) }}
        </template>

        <template v-slot:cell(file_name)="data">
          <img
            src="@/assets/images/small-icons/File_type_icon.png"
            alt="file icon"
          />
          {{ data.item.file_name }}
        </template>

        <template v-slot:cell(marketplace)="data">
          <span class="text-chai"><img v-if="marketplaceIcons[data.item.marketplace]" :src="marketplaceIcons[data.item.marketplace]" width="24" :alt="data.item.marketplace" class="mr-1 rounded-circle" :style="data.item.marketplace === 'SHOPEE' ? 'border: 1px solid #FF6533; background-color: #FF6533;' : ''" />{{ data.item.marketplace }}</span>
        </template>

        <template v-slot:cell(country)="data">
          <b-img
            :src="flags[data.item.country]"
            :class="{ 'mr-1': true, 'd-none': !flags[data.item.country] }"
            width="16"
            :alt="data.item.country"
          />{{ data.item.country }}
        </template>

        <template v-slot:cell(from_date)="data">
          {{ data.item.from_date | date }}
        </template>

        <template v-slot:cell(to_date)="data">
          {{ data.item.to_date | date }}
        </template>

        <template v-slot:cell(generated_at)="data">
          <div>
            <div>{{ data.item.generated_at | localDate }}</div>
            <div class="section-text">
              at {{ data.item.generated_at | localTime }}
            </div>
          </div>
        </template>

        <template v-slot:cell(report_type)="data">
          {{
            data.item.report_type === "consolidated_report"
              ? "Consolidated"
              : "Brand"
          }}
        </template>

        <template v-slot:cell(status)="data">
          <b-btn
            class="badge custom-status badge-soft-secondary border-0"
            v-if="data.item.status === 'Successful'"
            :disabled="isRowDownloading(getRowKey(data.item))"
            @click="downloadReport(data.item.file_link, data.item.files_links, getRowKey(data.item))"
          >
            <b-spinner v-if="isRowDownloading(getRowKey(data.item))" small class="mr-1"></b-spinner>
            <svg
              v-else
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <g opacity="0.7">
                <path
                  d="M10.96 5.9335C13.36 6.14016 14.34 7.3735 14.34 10.0735V10.1602C14.34 13.1402 13.1467 14.3335 10.1667 14.3335H5.82665C2.84665 14.3335 1.65332 13.1402 1.65332 10.1602V10.0735C1.65332 7.3935 2.61999 6.16016 4.97999 5.94016M7.99999 1.3335V9.92016"
                  stroke="black"
                  stroke-width="1.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M10.2333 8.43311L7.99994 10.6664L5.7666 8.43311"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
            </svg>
          </b-btn>
          <div
            class="badge custom-status badge-teal"
            v-else-if="data.item.status === 'Initiated'"
          >
            <img
              src="@/assets/images/small-icons/refresh-2.png"
              alt="refresh"
            />
          </div>
          <div class="badge custom-status badge-soft-danger" v-else>
            <img
              src="@/assets/images/small-icons/close-circle.png"
              alt="close-circle"
            />
          </div>
        </template>
      </b-table>

      <div class="d-flex justify-content-between">
        <per-page
          v-model="perPage"
          :currentPage="currentPage"
          :totalRows="rows"
          :tableRowsCount="tableData.length"
          @input="fetchReconReports"
        />
        <b-pagination
          class="my-auto"
          v-model="currentPage"
          :current-page="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          @input="fetchReconReports"
        ></b-pagination>
      </div>

      <b-modal
        id="reports-modal"
        no-close-on-backdrop
        hide-header
        hide-footer
        size="lg"
        content-class="reports_modal"
        body-class="p-0"
        @hidden="resetForm"
        @show="resetForm"
      >
        <div class="p-3">
          <div class="d-flex justify-content-between">
            <div>
              <p class="section-title">Create New Report</p>
              <p class="section-text">
                Use filters to customize and create your report your way.
              </p>
              <p
                v-if="unresolvedQaLogs.groups && unresolvedQaLogs.groups.length"
                class="qa-logs-link text-danger mt-2 mb-0 cursor-pointer d-flex align-items-center"
                @click="$bvModal.show('unresolved-qa-logs-modal')"
              >
                <svg
                  class="qa-logs-warning-icon"
                  viewBox="0 0 16 16"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 1.33333C7.63333 1.33333 7.28667 1.53 7.09333 1.85333L1.32667 11.6667C1.14 11.98 1.14 12.3733 1.32667 12.6867C1.51333 13 1.84667 13.1667 2.2 13.1667H13.8C14.1533 13.1667 14.4867 13 14.6733 12.6867C14.86 12.3733 14.86 11.98 14.6733 11.6667L8.90667 1.85333C8.71333 1.53 8.36667 1.33333 8 1.33333Z"
                    fill="#F5B400"
                  />
                  <path
                    d="M8 5C8.36819 5 8.66667 5.29848 8.66667 5.66667V8.66667C8.66667 9.03486 8.36819 9.33333 8 9.33333C7.63181 9.33333 7.33333 9.03486 7.33333 8.66667V5.66667C7.33333 5.29848 7.63181 5 8 5Z"
                    fill="white"
                  />
                  <path
                    d="M8 10.6667C7.63181 10.6667 7.33333 10.9651 7.33333 11.3333C7.33333 11.7015 7.63181 12 8 12C8.36819 12 8.66667 11.7015 8.66667 11.3333C8.66667 10.9651 8.36819 10.6667 8 10.6667Z"
                    fill="white"
                  />
                </svg>
                <span>
                  Some reports are unavailable for certain date ranges due to Marketplace changes. View affected brands →
                </span>
              </p>
            </div>
            <CloseModalBtn
              @close-button-clicked="$bvModal.hide('reports-modal')"
            />
          </div>

          <hr />

          <div v-if="!isBrandReport">
            <div class="row">
              <div class="col-md-6">
                <label class="">{{ $t("Marketplace") }}</label>
                <Multiselect
                  v-model="form.marketplace"
                  :options="marketplaces"
                  :placeholder="$t('Marketplace')"
                  track-by="name"
                  label="name"
                  :searchable="true"
                  :class="$v.form.marketplace.$error ? 'is-invalid' : ''"
                  class="custom-multiselect"
                ></Multiselect>
                <div
                  v-if="$v.form.marketplace.$error"
                  class="text-danger font-12px mt-2"
                >
                  This is a required field.
                </div>
              </div>
              <div class="col-md-6">
                <label class="">{{ $t("Account ID") }}</label>
                <Multiselect
                  v-model="form.account_id"
                  :options="form.marketplace ? form.marketplace.brands : []"
                  :placeholder="$t('Account ID')"
                  track-by="id"
                  label="id"
                  :searchable="true"
                  :disabled="!form.marketplace"
                  :class="$v.form.account_id.$error ? 'is-invalid' : ''"
                  class="custom-multiselect"
                ></Multiselect>
                <div
                  v-if="$v.form.account_id.$error"
                  class="text-danger font-12px mt-2"
                >
                  This is a required field.
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-6">
                <label class="">{{ $t("Country") }}</label>
                <Country
                  :country="form.country"
                  @country-changed="(value) => form.country = value"
                  :countries="form.account_id ? form.account_id.countries : []"
                  v-model="form.country"
                  label="name"
                  :invalid="$v.form.country.$error"
                  :disabled="!form.account_id"
                />
                <div
                  v-if="$v.form.country.$error"
                  class="text-danger font-12px mt-2"
                >
                  This is a required field.
                </div>
              </div>
  
              <div class="col-md-6" v-if="form.country && form.country.date_types">
                <label class="">{{ $t("Date Type") }}</label>
                <Multiselect
                  v-model="form.date_type"
                  :options="form.country ? form.country.date_types : []"
                  :placeholder="$t('Date Type')"
                  track-by="name"
                  label="display_name"
                  :searchable="true"
                  :disabled="!form.country"
                  :class="$v.form.date_type.$error ? 'is-invalid' : ''"
                  class="custom-multiselect"
                  ></Multiselect>
                <div
                  v-if="$v.form.date_type.$error"
                  class="text-danger font-12px mt-2"
                >
                  This is a required field.
                </div>
              </div>
  
              <div class="col-md-6" v-if="!form.country || !form.country.date_types">
                <label class="">{{ $t("Order Type") }}</label>
                <Multiselect
                  v-model="form.order_type"
                  :options="form.country ? form.country.order_types : []"
                  :placeholder="$t('Order Type')"
                  track-by="name"
                  label="display_name"
                  :searchable="true"
                  :disabled="!form.country"
                  :class="$v.form.order_type.$error ? 'is-invalid' : ''"
                  class="custom-multiselect"
                  ></Multiselect>
                <div
                  v-if="$v.form.order_type.$error"
                  class="text-danger font-12px mt-2"
                >
                  This is a required field.
                </div>
              </div>
            </div>
            <div class="row mt-4" v-if="isAmazon && form.date_type && form.date_type.order_types">
              <div class="col-md-6">
                <label class="">{{ $t("Order Type") }}</label>
                <Multiselect
                  v-model="form.order_type"
                  :options="form.date_type.order_types"
                  :placeholder="$t('Order Type')"
                  track-by="name"
                  label="display_name"
                  :searchable="true"
                  :class="$v.form.order_type.$error ? 'is-invalid' : ''"
                  class="custom-multiselect"
                ></Multiselect>
                <div
                  v-if="$v.form.order_type.$error"
                  class="text-danger font-12px mt-2"
                >
                  This is a required field.
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-4" v-if="!form.marketplace || form.marketplace.name !== 'SHOPIFY'">
                <label class="d-block">{{ $t("Date Range") }}</label>
                <DaySelection
                  :day="day"
                  @day-selected="dayChanged"
                  format="YYYY-MM-DD"
                  class="w-100"
                  :disabled="!form.order_type && (!form.date_type || (isAmazon && form.date_type && form.date_type.order_types))"
                  :invalid="$v.day.$error"
                  :dayOptions="dayOptions"
                  label="label"
                />
                <div v-if="$v.day.$error" class="text-danger font-12px mt-2">
                  This is a required field.
                </div>
              </div>
              <div class="col-md-4" v-if="isSettlementMonthAvailable">
                <label class="d-flex justify-content-between">
                  <span>{{ $t("Settlement Month") }}</span>
                  <!-- Explicit clear: going back to From/To must always be possible (ENG-1175 review). -->
                  <a
                    v-if="form.settlement_month"
                    href="#"
                    class="font-12px"
                    @click.prevent="clearSettlementMonth"
                    >{{ $t("Clear") }}</a
                  >
                </label>
                <date-picker
                  type="month"
                  format="MM/YYYY"
                  v-model="form.settlement_month"
                  name="settlement_month"
                  prefix-class="xmx"
                  :clearable="true"
                  class="w-100 dtpicker settlement-month-picker"
                  :placeholder="$t('Optional')"
                  :disabled-date="disabledSettlementMonth"
                >
                  <i slot="icon-calendar">
                    <img src="@/assets/images/calendar.png" alt="Filter" />
                  </i>
                </date-picker>
                <div class="text-muted font-12px mt-2">
                  {{ $t("Pick a month instead of From/To to get each PSP's close for that month.") }}
                </div>
              </div>
              <div class="col-md-4" v-if="!form.marketplace || form.marketplace.name !== 'SHOPEE' || day === 'Custom'">
                <label class="d-block">{{ $t("From") }}</label>
                <date-picker
                  type="date"
                  format="DD/MM/YYYY"
                  v-model="form.from_date"
                  :open.sync="openDatePickerFrom"
                  name="from_date"
                  prefix-class="xmx"
                  :disabled="isSettlementMonthMode || (!form.order_type && (!form.date_type || (isAmazon && form.date_type && form.date_type.order_types)))"
                  :class="{
                    'is-invalid': $v.form.from_date.$error,
                    dtpicker: true,
                  }"
                  @change="(day = 'Custom'), (openDatePickerTo = true)"
                  :disabled-date="disabledFromDate"
                >
                  <i slot="icon-calendar">
                    <img src="@/assets/images/calendar.png" alt="Filter" />
                  </i>
                </date-picker>
                <div
                  v-if="$v.form.from_date.$error"
                  class="text-danger font-12px mt-2"
                >
                  This is a required field.
                </div>
              </div>
              <div class="col-md-4" v-if="!form.marketplace || form.marketplace.name !== 'SHOPEE' || day === 'Custom'">
                <label class="d-block">{{ $t("To") }}</label>
                <date-picker
                  type="date"
                  format="DD/MM/YYYY"
                  v-model="form.to_date"
                  :open.sync="openDatePickerTo"
                  name="to_date"
                  prefix-class="xmx"
                  :class="{
                    'is-invalid': $v.form.to_date.$error,
                    dtpicker: true,
                  }"
                  :disabled="isSettlementMonthMode || (!form.order_type && (!form.date_type || (isAmazon && form.date_type && form.date_type.order_types)))"
                  @change="day = 'Custom'"
                  :disabled-date="disabledToDate"
                >
                  <i slot="icon-calendar">
                    <img src="@/assets/images/calendar.png" alt="Filter" />
                  </i>
                </date-picker>
                <div
                  v-if="$v.form.to_date.$error"
                  class="text-danger font-12px mt-2"
                >
                  This is a required field.
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-md-6" v-if="form.marketplace && form.marketplace.name == 'TIKTOK'">
                <div class="filter_channel">
                    <div class="filter_channel_section">
                      <div class="checkbox-parent" >
                        <div class="checkbox-group">  
                          <input type="checkbox" :id="`filter_generate_generic_report`" :value="generate_generic_report" v-model="generate_generic_report">
                          <label :for="`filter_generate_generic_report`">Generate Generic Report</label>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="row mt-4">
              <div class="col-md-6">
                <label class="">{{ $t("Country") }}</label>
                <Country
                  :country="form.country"
                  @country-changed="(value) => form.country = value"
                  :countries="brandReportFilters.countries"
                  v-model="form.country"
                  :invalid="$v.form.country.$error"
                />
                <div
                  v-if="$v.form.country.$error"
                  class="text-danger font-12px mt-2"
                >
                  This is a required field.
                </div>
              </div>

              <div class="col-md-6">
                <label class="">{{ $t("Brand") }}</label>
                <Multiselect
                  v-model="form.brand"
                  :options="brandReportFilters.brands"
                  :placeholder="$t('Brand')"
                  :searchable="true"
                  :class="$v.form.brand.$error ? 'is-invalid' : ''"
                  class="custom-multiselect"
                  ></Multiselect>
                  <div
                    v-if="$v.form.brand.$error"
                    class="text-danger font-12px mt-2"
                  >
                    This is a required field.
                  </div>
              </div>

              <div class="mt-4 col-md-6">
                <label class="d-block">{{ $t("Select Month") }}</label>
                <date-picker
                  type="month"
                  format="MM/YYYY"
                  v-model="form.report_month"
                  name="report_month"
                  prefix-class="xmx"
                  class="w-100"
                  :disabled-date="disabledReportMonth"
                  :class="{
                    'is-invalid': $v.form.report_month.$error,
                    dtpicker: true,
                  }"
                >
                  <i slot="icon-calendar">
                    <img src="@/assets/images/calendar.png" alt="Filter" />
                  </i>
                </date-picker>
                <div
                  v-if="$v.form.report_month.$error"
                  class="text-danger font-12px mt-2"
                >
                  This is a required field.
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="px-3 pb-3 pt-4 mt-4 border-top d-flex justify-content-end"
          style="box-shadow: 0px -4px 10px 0px rgba(220, 218, 213, 0.30);"
        >
          <b-button
            variant="white"
            class="mr-2 bg-white text-dark cancel"
            @click="$bvModal.hide('reports-modal')"
            >{{ $t("button.cancel") }}</b-button
          >
          <b-button
            variant="primary"
            class="btn-padding"
            @click="createReport"
            :disabled="processing"
            >{{ $t("Create Report") }}</b-button
          >
        </div>
      </b-modal>
      <b-modal
        id="unresolved-qa-logs-modal"
        hide-footer
        size="lg"
        title="Report availability"
      >
        <div
          class="qa-logs-card"
          v-if="(unresolvedQaLogs.groups && unresolvedQaLogs.groups.length) || isFetchingUnresolvedQaLogs"
        >
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div>
              <p class="qa-logs-title mb-1">Report availability</p>
              <p class="qa-logs-subtitle mb-0">
                Reports cannot be created for the amber date ranges below.
              </p>
            </div>
            <b-spinner
              v-if="isFetchingUnresolvedQaLogs"
              small
              class="text-muted"
            ></b-spinner>
          </div>
          <div v-if="unresolvedQaLogs.groups && unresolvedQaLogs.groups.length">
            <div class="table-responsive">
              <table class="table qa-logs-table mb-0">
                <thead>
                  <tr>
                    <th class="qa-logs-header-cell">Brand</th>
                    <th class="qa-logs-header-cell">Country</th>
                    <th
                      v-for="marketplace in qaMarketplaces"
                      :key="marketplace"
                      class="qa-logs-header-cell text-center"
                    >
                      <span class="text-uppercase">{{ marketplace }}</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="group in unresolvedQaLogs.groups"
                    :key="group.brand + '-' + group.country"
                  >
                    <td class="qa-logs-body-cell font-weight-semibold">
                      {{ group.brand }}
                    </td>
                    <td class="qa-logs-body-cell">
                      <b-img
                        :src="flags[group.country]"
                        :class="{ 'mr-1': true, 'd-none': !flags[group.country] }"
                        width="16"
                        :alt="group.country"
                      />
                      {{ group.country }}
                    </td>
                    <td
                      v-for="marketplace in qaMarketplaces"
                      :key="group.brand + '-' + group.country + '-' + marketplace"
                      class="qa-logs-body-cell"
                    >
                      <div
                        v-if="getDateRangesForMarketplace(group, marketplace).length"
                      >
                        <span
                          v-for="range in getDateRangesForMarketplace(group, marketplace)"
                          :key="range.log_reference_id"
                          class="qa-logs-badge"
                          v-b-tooltip.hover.top
                          :title="range.message"
                        >
                          <span class="qa-logs-badge-dot"></span>
                          {{ formatQaDateRange(range.from_date, range.to_date) }}{{ range.order_type ? ` (${range.order_type})` : '' }}
                        </span>
                      </div>
                      <span v-else class="text-muted">—</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p class="qa-logs-footnote mt-2 mb-0">
              <span class="qa-logs-badge-dot mr-1"></span>
              Amber badge = restricted period. Hover to see QA error message.
            </p>
          </div>
        </div>
        <div
          v-else
          class="text-muted"
        >
          No current QA restrictions.
        </div>
      </b-modal>
    </div>
  </Layout>
</template>

<style scoped>
::v-deep .xmx-input {
  /* padding-left: 30px; */
  padding: 13px;
  padding-left: 35px;
  height: 44px;
  border-radius: 12px;
  border: 1px solid #dcdad5;
  background: transparent;
  font-size: 14px;
  font-weight: 500;
  color: #000;
}

.checkbox-parent.active{
    background: rgba(220, 218, 213, 0.30);
}
.checkbox-parent label{
  margin-bottom: 0px;
  font-size: 15px;
}

.checkbox-group{
  position: relative;
}
.checkbox-group input{
  display: none;
}
.checkbox-group  label {
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
}
.checkbox-group  label:before {
  content:'';
  -webkit-appearance: none;
  background-color: #fff;
  border: 1px solid #DAD9D9;
  border-radius: 4px;
  padding: 7px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  cursor: pointer;
  margin-right: 10px;
  bottom:1px;
}
.checkbox-group input:checked+label:before {
  background-color: #252B3A;
  border: 1px solid #252B3A;
}

.checkbox-group input:checked+label:after {
  content: '';
  display: block;
  position: absolute;
  top: 3px;
  left: 6px;
  width: 5px;
  height: 9px;
  border: 1px solid #fff;
  border-width: 0px 2px 2px 0px;
  transform: rotate(45deg);
}

.xmx-icon-calendar img {
  width: 17px;
  height: 17px;
}

::v-deep .xmx-icon-calendar {
  left: 10px;
}
::v-deep .dtpicker {
  width: 100%;
}
/* The global rule in _general.scss keeps the calendar icon visible on hover, on top of the picker's
   clear (×) icon, so a selected Settlement Month could not be cleared. Let the clear icon through here. */
::v-deep .settlement-month-picker .xmx-input-wrapper:hover .xmx-icon-clear + .xmx-icon-calendar {
  display: none !important;
}
::v-deep #day-selection .dropdown-toggle {
  overflow-x: scroll;
}
.qa-logs-link {
  font-size: 12px;
  font-weight: 600;
}

.qa-logs-warning-icon {
  width: 14px;
  height: 14px;
  margin-right: 6px;
  flex-shrink: 0;
}

.qa-logs-card {
  border-radius: 16px;
  border: 1px solid #e5e2da;
  background: #fdfbf7;
  padding: 20px 24px;
}

.qa-logs-title {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #716a5c;
}

.qa-logs-subtitle {
  font-size: 13px;
  color: #7b7467;
}

.qa-logs-table thead th {
  border-top: none;
  border-bottom: 1px solid #ebe7df;
  font-size: 12px;
  text-transform: uppercase;
  color: #8a8374;
  font-weight: 700;
  background-color: transparent;
}

.qa-logs-table tbody td {
  border-top: none;
  border-bottom: 1px solid #f0ece3;
  font-size: 13px;
  color: #3b3429;
  vertical-align: middle;
}

.qa-logs-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  background: #ffe9a9;
  color: #7a5e00;
  font-size: 12px;
  font-weight: 600;
  margin-right: 6px;
  margin-bottom: 4px;
}

.qa-logs-badge-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #f5b400;
  margin-right: 6px;
}

.qa-logs-footnote {
  font-size: 12px;
  color: #9a9387;
}
</style>
